var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwomark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2471_1744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58326 15C4.26326 15 3.94326 14.8784 3.6991 14.6342L0.365762 11.3009C-0.122572 10.8125 -0.122572 10.0217 0.365762 9.53336C0.854095 9.04503 1.64493 9.04503 2.13326 9.53336L4.58326 11.9825L12.0324 4.53336C12.5208 4.04503 13.3116 4.04503 13.7999 4.53336C14.2883 5.0217 14.2883 5.81253 13.7999 6.30086L5.4666 14.6342C5.22326 14.8784 4.90326 15 4.58326 15Z",
    fill: "#229B61",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4168 15C10.0968 15 9.77676 14.8784 9.53259 14.6342L6.19926 11.3009C5.71092 10.8125 5.71092 10.0217 6.19926 9.53336C6.68759 9.04503 7.47842 9.04503 7.96676 9.53336L10.4159 11.9825L17.8651 4.53336C18.3534 4.04503 19.1443 4.04503 19.6326 4.53336C20.1209 5.0217 20.1209 5.81253 19.6326 6.30086L11.2993 14.6342C11.0568 14.8784 10.7368 15 10.4168 15Z",
    fill: "#229B61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2471_1744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwomark);
export default __webpack_public_path__ + "static/media/twomark.7adb7aa5b2598c5fb1ab117f6d880b3c.svg";
export { ForwardRef as ReactComponent };